(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/theme-helpers/assets/javascripts/format-time.js') >= 0) return;  svs.modules.push('/components/themes/theme-helpers/assets/javascripts/format-time.js'); "use strict";

(function (svs) {
  var formatTime = function formatTime(time) {
    return new Date(time).toTimeString().slice(0, 5);
  };

  svs.themes.formatTime = formatTime;
})(svs);
 })(window);